import { Box } from "@mui/material";
import { useState } from "react";
import DotLegalAutocomplete, { AutocompleteOption } from "../../common/autocomplete/DotLegalAutocomplete";
import { Organization } from "./Organization.types";

export interface IConfigureRenewalRegistrationActive {
    organization: Organization;
    onOrganizationChanged: (organization: Organization) => void;
}

export default function ConfigureRenewalRegistrationActive(props: IConfigureRenewalRegistrationActive) {
    const [OrganizationRenewalOptions] = useState<AutocompleteOption<boolean>[]>([
        { label: "Hide renewal status", value: false },
        { label: "Show renewal status", value: true },
    ]);
    const [selectedRenewalPrice, setSelectedRenewalPrice] = useState<AutocompleteOption<boolean>>(
        OrganizationRenewalOptions.find((option) => option.value === props.organization.renewalRegistrationActive)!
    );

    const onRenewalRegistrationActiveChange = (newValue: AutocompleteOption<boolean>[]) => {
        setSelectedRenewalPrice(newValue[0] ?? { label: "No", value: false });
        props.onOrganizationChanged({
            ...props.organization,
            renewalRegistrationActive: newValue[0]?.value ?? false,
        });
    };

    return (
        <Box sx={(theme) => ({ display: "flex", width: "100%", flexDirection: "column", gap: theme.spacing(5.5), alignItems: "center" })}>
            <Box id="singleSelectDropdown" sx={{ width: 270 }}>
                <DotLegalAutocomplete
                    onChange={onRenewalRegistrationActiveChange}
                    label="Renewal status"
                    options={OrganizationRenewalOptions}
                    singleSelect
                    // @ts-ignore
                    value={selectedRenewalPrice}
                    width={"100%"}
                    tooltip={`Renewal status refers to the “Renewal status” column under the menu item “Renewals”. By default, this column is visible, allowing users to select whether a trademark, design or watch should be renewed or expire. If you prefer to hide this column, select “Hide renewal status”.`}
                />
            </Box>
        </Box>
    );
}
